import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import ImageWrapper from 'components/helpers/ImageWrapper/ImageWrapper';
import { classnames } from 'tailwindcss-classnames';
import ImageCaption from 'components/helpers/ImageCaption/ImageCaption';

export type ImageBlockProps = Sitecore.Override.ComponentBase &
  Components.General.ImageBlock.Fields.ImageBlock;
const ImageBlock = ({ fields }: ImageBlockProps): JSX.Element => {
  // Fail out if we don't have any fields
  if (!fields) {
    return <></>;
  }
  // Build component class list
  const componentClasses = classnames(
    'image-block',
    fields?.applyCircleFilter?.value || 0 ? 'image-block-rounded' : undefined
  );
  // Return Element
  return (
    <div data-component="authorable/general/image-block" className={classnames(componentClasses)}>
      <div className={classnames('relative')}>
        <ImageWrapper field={fields.featuredImage} layout="responsive" />
        <ImageCaption imageCaption={fields.imageCaption} classNames={classnames('p-4')} />
      </div>
    </div>
  );
};

export default ImageBlock;
